module.exports = __webpack_public_path__ + "static/media/Collection_3.2779ca31.jpg";